define(function (require) {
    "use strict";

    var template = require("manager-templates/data-sources/attributes/tooltipListItemView.tmpl");

    var TooltipListItemView = {};

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {

        TooltipListItemView = Marionette.ItemView.extend({

            template:template,
            tagName:'li',
            className:'tooltip-edit-item',

            initialize: function(options){
                LEManager.logger.debug("TooltipListItemView:initialize");
            },

            customTemplateHelpers: function() {
                return {
                    tooltipName: LE.translator.translate('LEManager.manager.dataSources.item.tooltip.' + this.model.get("name"))
                };
            },
            onClose: function(){
                LEManager.logger.debug("TooltipListItemView:onClose");
            }

        });
    });

    return TooltipListItemView;
});